module.exports = __webpack_public_path__ + "static/media/provider-hero.2a768ef8.png";